export default __webpack_public_path__ + "c740ec21e7d6ede5a46132035abb4eca.jpg";